<template>
  <v-main>
    <v-container fluid>
      <v-btn fab x-small color="white" class="mb-4" @click="$router.back()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-container fluid>
        <v-card elevation="10" rounded="xl" class="pa-4">
          <v-row justify="center" class="ma-0">
            <v-col cols="12" sm="6" class="text-center">
              <span class="text-subtitle-1 primary--text"
                >Supervisor Name:</span
              >
            </v-col>
            <v-col cols="12" sm="6" class="text-center">
              <span class="text-subtitle-1">{{ user.full_name }}</span>
            </v-col>
          </v-row>
          <v-row justify="center" class="ma-0">
            <v-col cols="12" class="text-center">
              <v-img
                :src="require('@/assets/voe_imgs/referral-form-deom.png')"
                alt="Profile"
                max-height="140"
                max-width="160"
                class="mx-auto"
              />
            </v-col>
          </v-row>

          <v-form ref="form" v-model="valid" @submit.prevent="save">
            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">Name</h5>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-text-field
                  v-model="form.name"
                  placeholder="Name"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.name"
                  :rules="[(v) => !!v || 'Name is required']"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">Phone No</h5>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-text-field
                  v-model="form.phone_no"
                  placeholder="Phone No"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.phone_no"
                  :rules="[(v) => !!v || 'Phone number is required']"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">Address</h5>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-text-field
                  v-model="form.address"
                  placeholder="Address"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.address"
                  :rules="[(v) => !!v || 'Address is required']"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">Designation</h5>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-text-field
                  v-model="form.designation"
                  placeholder="Designation"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.designation"
                  :rules="[(v) => !!v || 'Designation is required']"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">Photo Upload</h5>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-file-input
                  v-model="form.image_path"
                  placeholder="Upload Photo"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.image_path"
                  accept="image/*"
                  prepend-icon="mdi-camera"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">Pan Card Details</h5>
              </v-col>
              <v-col cols="12" sm="4" class="py-1">
                <v-text-field
                  v-model="form.pan_no"
                  placeholder="Pan Card Number"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.pan_no"
                  :rules="[(v) => !!v || 'PAN number is required']"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-1">
                <v-file-input
                  v-model="form.pan_card_image"
                  placeholder="Upload PAN Card"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.pan_card_image"
                  accept="image/*"
                  prepend-icon="mdi-card"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">Aadhaar Card Details</h5>
              </v-col>
              <v-col cols="12" sm="4" class="py-1">
                <v-text-field
                  v-model="form.aadhar_no"
                  placeholder="Aadhaar Card Number"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.aadhar_no"
                  :rules="[(v) => !!v || 'Aadhaar number is required']"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-1">
                <v-file-input
                  v-model="form.aadhar_card_image"
                  placeholder="Upload Aadhaar Card"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.aadhar_card_image"
                  accept="image/*"
                  prepend-icon="mdi-card"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">Bank Account Number</h5>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-text-field
                  v-model="form.bank_no"
                  placeholder="Bank Account Number"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.bank_no"
                  :rules="[(v) => !!v || 'Bank account number is required']"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">IFSC Code</h5>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-text-field
                  v-model="form.bank_ifsc_code"
                  placeholder="Enter IFSC Code"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.bank_ifsc_code"
                  :rules="[(v) => !!v || 'IFSC code is required']"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" align="center">
              <v-col cols="12" sm="4" class="py-1">
                <h5 class="text-h6">Passbook Upload</h5>
              </v-col>
              <v-col cols="12" sm="8" class="py-1">
                <v-file-input
                  v-model="form.passbook_image"
                  placeholder="Upload Passbook"
                  outlined
                  dense
                  rounded
                  :error-messages="errors.passbook_image"
                  accept="image/*"
                  prepend-icon="mdi-book"
                  :rules="[(v) => !!v || 'Passbook image is required']"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0" justify="center">
              <v-col cols="12" sm="6" class="text-center">
                <v-btn
                  color="primary"
                  rounded
                  :loading="isLoading"
                  :disabled="!valid"
                  type="submit"
                  width="200"
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-container>
    </v-container>
    <v-container class="footer-text">
      <v-row justify="center">
        <v-col class="text-center">
          <h3 class="white--text">We Alliance Sparkle</h3>
          <h4 class="white--text">v 1.0.0</h4>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "ReferralForm",
  data() {
    return {
      form: {
        name: "",
        phone_no: "",
        address: "",
        designation: "",
        image_path: null,
        pan_no: "",
        pan_card_image: null,
        aadhar_no: "",
        aadhar_card_image: null,
        bank_no: "",
        bank_ifsc_code: "",
        passbook_image: null,
      },
      errors: {},
      valid: false,
      isLoading: false,
      response: null,
    };
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;
      this.errors = {};

      try {
        const formData = new FormData();
        formData.append("referrer_id", this.user.id);
        Object.keys(this.form).forEach((key) => {
          if (this.form[key] && key.includes("image")) {
            formData.append(key, this.form[key]);
          } else if (this.form[key]) {
            formData.append(key, this.form[key]);
          }
        });

        const response = await axios.post("/referral_requests", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.response = response.data.data;
        this.$refs.form.reset();
        this.$emit("success", "Referral submitted successfully");
      } catch (error) {
        this.errors = error.response?.data?.errors || {
          general: "An error occurred",
        };
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  max-width: 800px;
  margin: 0 auto;
}
.v-text-field,
.v-file-input {
  max-width: 400px;
}
.footer-text {
  padding: 16px 0;
}
@media (max-width: 600px) {
  .v-text-field,
  .v-file-input {
    max-width: 100%;
  }
}
</style>
